import { createAction } from '@reduxjs/toolkit';
import type { QrDesignViewerState } from '../reducers/qr-design-viewer';
import type { AppThunk } from '../store/configureStore';

type Organization = QrDesignViewerState['organization'];
type Shop = QrDesignViewerState['shop'];

export const SET_ORGANIZATION = createAction<Organization>('QR_DESIGNER_VIEWER_SET_ORGANIZATION');
export const SET_SHOP = createAction<Shop>('QR_DESIGNER_SET_SHOP');

export const setOrganization =
  (orgCode: Organization): AppThunk =>
  (dispatch) =>
    dispatch(SET_ORGANIZATION(orgCode));

export const setShop =
  (shop: Shop): AppThunk =>
  (dispatch) =>
    dispatch(SET_SHOP(shop));
